import { AccountErrorCode } from "@dashboard/graphql";
import { defineMessages, type IntlShape } from "react-intl";

import { getCommonFormFieldErrorMessage } from "./common";

const messages = defineMessages({
  invalidPassword: {
    id: "eu98dw",
    defaultMessage: "Invalid password",
  },
  outOfScopeGroup: {
    id: "1n1tOR",
    defaultMessage: "Group is out of your permission scope",
  },
  outOfScopeUser: {
    id: "KRqgfo",
    defaultMessage: "User is out of your permissions scope",
  },
  passwordNumeric: {
    id: "cY42ht",
    defaultMessage: "Password cannot be entirely numeric",
  },
  tooCommon: {
    id: "wn3di2",
    defaultMessage: "This password is too commonly used",
  },
  tooShort: {
    id: "LR3HlT",
    defaultMessage: "This password is too short",
  },
  tooSimilar: {
    id: "1wyZpQ",
    defaultMessage: "These passwords are too similar",
  },
  unique: {
    id: "TDhHMi",
    defaultMessage: "This needs to be unique",
  },
  uniqueEmail: {
    id: "froISM",
    defaultMessage: "User with this email already exists",
  },
  invalidEmail: {
    id: "YRe93Y",
    defaultMessage: "Enter a valid email address",
  },
  invalidToken: {
    id: "ByYtFB",
    defaultMessage: "Invalid or expired token. Please check your token in URL",
  },
  userNotFound: {
    id: "tR+UuE",
    defaultMessage: "User doesn't exist. Please check your email in URL",
  },
});

interface ErrorFragment {
  code: AccountErrorCode;
  field: string | null;
  message?: string | null;
}

function getAccountErrorMessage(err: ErrorFragment, intl: IntlShape): string | undefined {
  if (err) {
    switch (err.code) {
      case AccountErrorCode.INVALID_PASSWORD:
        return intl.formatMessage(messages.invalidPassword);
      case AccountErrorCode.OUT_OF_SCOPE_USER:
        return intl.formatMessage(messages.outOfScopeUser);
      case AccountErrorCode.OUT_OF_SCOPE_GROUP:
        return intl.formatMessage(messages.outOfScopeGroup);
      case AccountErrorCode.PASSWORD_ENTIRELY_NUMERIC:
        return intl.formatMessage(messages.passwordNumeric);
      case AccountErrorCode.PASSWORD_TOO_COMMON:
        return intl.formatMessage(messages.tooCommon);
      case AccountErrorCode.PASSWORD_TOO_SHORT:
        return intl.formatMessage(messages.tooShort);
      case AccountErrorCode.PASSWORD_TOO_SIMILAR:
        return intl.formatMessage(messages.tooSimilar);
      case AccountErrorCode.UNIQUE:
        if (err.field === "email") {
          return intl.formatMessage(messages.uniqueEmail);
        }

        return intl.formatMessage(messages.unique);
      case AccountErrorCode.INVALID:
        if (err.field === "email") {
          return intl.formatMessage(messages.invalidEmail);
        }

        // Password-reset / set-password flows use INVALID for bad tokens.
        return intl.formatMessage(messages.invalidToken);
      case AccountErrorCode.NOT_FOUND:
        return intl.formatMessage(messages.userNotFound);
    }
  }

  return getCommonFormFieldErrorMessage<AccountErrorCode>(err, intl);
}

export default getAccountErrorMessage;
